/* Format turn */
export default (value) => {
    let str = '';
    if(value.start_morning)
    {
        str += value.start_morning + ' - ' +value.end_morning;
    }
    if(value.start_evening)
    {
        str += '\t' + value.start_evening + ' - ' +value.end_evening;;
    }
    if(str.length == 0)
    {
        return '-';
    }
    return str;
}


// WEBPACK FOOTER //
// ./src/filters/formatTurn.js